import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {verifyAuthCaptcha} from 'api/auth';
import Cookies from 'utils/cookies';

import {
  FormGroup,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Button,
} from 'reactstrap';
import IPCaptcha from './IPCaptcha';
import CaptchaAlternativeLink from './CaptchaAlternativeLink';

const propTypes = {
  initialCheck: PropTypes.bool,
  onClose: PropTypes.func,
  showChildren: PropTypes.bool,
  children: PropTypes.func,
};

const defaultProps = {
  showChildren: true,
  initialCheck: false,
};

const CaptchaModal = ({initialCheck, onClose, showChildren, children}) => {
  const cookieCaptchaToken = Cookies.captchaToken || '';

  const [captchaToken, setCaptchaToken] = useState(cookieCaptchaToken || '');
  const [isOpen, setIsOpen] = useState(initialCheck && !cookieCaptchaToken);
  const [isLoading, setIsLoading] = useState(false);

  // Verify captcha on mount if initialCheck is true
  useEffect(() => {
    if (initialCheck) {
      verifyCaptcha();
    }
  }, [initialCheck]);

  // Handler for closing modal
  const handleClose = (e) => {
    e.preventDefault();

    if (onClose) {
      onClose();
    } else {
      setIsOpen(false);
    }
  };

  // Handler for verifying captcha
  const handleVerifyCaptchaCode = async (code, type) => {
    console.log('handleVerifyCaptcha', code, type);

    try {
      setIsLoading(true);
      const {data} = await verifyAuthCaptcha(type, {response: code});
      const {token_id} = data;

      Cookies.captchaToken = token_id;
      setCaptchaToken(token_id);
      setIsOpen(false);
    } catch (e) {
      throw e;
    } finally {
      setIsLoading(false);
    }
  };

  // check if captcha is saved in cookies
  const verifyCaptcha = () => {
    const token = Cookies.captchaToken || '';
    setCaptchaToken(token);
    setIsOpen(!token);
  };

  const isVerified = !!captchaToken;

  return (
    <>
      {(isVerified || showChildren) &&
        typeof children === 'function' &&
        children({
          isVerified,
          verifyCaptcha,
        })}

      <Modal centered isOpen={isOpen}>
        <ModalHeader>Security Verification</ModalHeader>
        <ModalBody>
          <p>
            Before you use IAF CertSearch, we need to confirm you are a human.
          </p>

          <div style={{maxWidth: '320px', margin: '0 auto'}}>
            <FormGroup className="my-4 d-flex justify-content-center flex-column">
              <IPCaptcha onVerify={handleVerifyCaptchaCode} />
              <div className="mt-2 text-center">
                <CaptchaAlternativeLink />
              </div>
            </FormGroup>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button onClick={handleClose} disabled={isLoading}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

CaptchaModal.propTypes = propTypes;
CaptchaModal.defaultProps = defaultProps;

export default CaptchaModal;
